import { toFullwidth, toFullwidthKana } from "japanese-string-utils";

export default class StringUtils {

    // Covert half width to full width
    public static toFullWidthJP(str: string | undefined): string {
        if (str == undefined) return '';
        return toFullwidth(toFullwidthKana(str));
    }

    /**
    * count byte for string
    */
    public static checkValidateInput(maxlength: number, event: any) {
        let len = 0;
        let tempstr = event;
        if (tempstr != undefined) {
            for (let i = 0; i < tempstr.length; i++) {
                let code = tempstr.charCodeAt(i);
                if ((code >= 0x0 && code < 0x81) || (code === 0xf8f0) || (code >= 0xff61 && code < 0xffa0) || (code >= 0xf8f1 && code < 0xf8f4)) {
                    len += 1;
                } else {
                    len += 2;
                }
            }
        }
        if (len <= maxlength) {
            return true;
        }
        else {
            return false;
        }
    }
}

export class StringExtension {
  constructor() {}

  /**
   * @param inputStr
   * @returns string
   */
  static getTagsByTagString(inputStr: string): string {
    if (!inputStr || inputStr.trim() === '') return '';

    // Remove starting '#' if it exists
    if (inputStr.startsWith('#')) {
      inputStr = inputStr.slice(1);
    }

    // Remove ending '#' if it exists
    if (inputStr.endsWith('#')) {
      inputStr = inputStr.slice(0, -1);
    }

    // Replace characters follow Japanese character conversion rules
    let items: string[] = [StringExtension.jpCharConvert(inputStr)];

    // Remove spaes, tabs, and newlines
    const tags = items
      .map(item => item.replace(/ /g, '').replace(/　/g, '').replace(/\t/g, '').trim())
      .join('');

    return `#${tags.trim()}`;
  }

  /**
   * Placeholder for Japanese character conversion
   * Replace ASCII punctuation with full-width Japanese equivalents, etc.
   * You need to implement this function based on your requirements.
   */
  private static jpCharConvert(input: string): string {
    // Example: simple replacement for a few chars (extend as needed)
    const map: { [key: string]: string } = {
      '!': '！',
      '"': '＂',
      '#': '＃',
      '$': '＄',
      '%': '％',
      '&': '＆',
      '\'': '＇',
      '(': '（',
      ')': '）',
      '=': '＝',
      '~': '～',
      '`': '｀',
      '{': '｛',
      '+': '＋',
      '*': '＊',
      '?': '？',
      '_': '＿',
      '-': '－',
      '^': '＾',
      '\\': '￥',
      '@': '＠',
      '[': '［',
      ';': '；',
      ':': '：',
      ']': '］',
      ',': '，',
      '.': '．',
      '/': '／',
      '<': '＜',
      '>': '＞',
    };

    return input.replace(/[!"#$%&'()=~`{+*}?_\-^\\@\[;:\],.\/<>]/g, (match) => map[match] || match);
  }
} 